import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';
import 'leaflet.wms/dist/leaflet.wms';
import { object } from 'prop-types';
import { district } from './lat_long';
import { overlay } from 'leaflet.wms';
import { useSelector } from 'react-redux';

const MapComponent = ({
  selectedState,
  stateCoordinates,
  token,
  selectedDistrict,
  countryProfileMap,
  selectedStrategy,
  selectedStateYear,
}) => {
  const { activityLegends } = useSelector((state) => state.dashboardDetail);
  const endemicPopulations = countryProfileMap?.state?.['TAS 2 Pass']?.map((item) => item['Endemic Population']);
  const EndemicDistricts = countryProfileMap?.state?.['TAS 2 Pass']?.map((item) => item['Endemic Districts']);
  const district = countryProfileMap?.state?.['TAS 2 Pass']?.map((item) => item.district);
  const Strategy = countryProfileMap?.state?.['TAS 2 Pass']?.map((item) => item.Strategy);
  const MDADistricts = countryProfileMap?.state?.['TAS 2 Pass']?.map((item) => item['MDA Districts']);
  const PreTASDistricts = countryProfileMap?.state?.['TAS 2 Pass']?.map((item) => item['Pre TAS Districts']);
  const TASclearedDistricts = countryProfileMap?.state?.['TAS 2 Pass']?.map(
    (item) => item['TAS cleared Districts'],
  );
  console.log(token, 'token');
  console.log(countryProfileMap, 'countryProfileMap');

  //console.log(selectedState, 'selectedState1');
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const countryProfile = countryProfileMap;
  console.log(countryProfile, 'countryProfile');

  const addStateLayer = (state) => {
    const legends = JSON.parse(JSON.stringify(activityLegends?.mapLegends));
    if (!stateCoordinates[state]) {
      console.error(`Coordinates not available for state: ${state}`, 'stateerror');
      return;
    }

    const [lat, lng] = stateCoordinates[state];

    if (lat === undefined || lng === undefined) {
      console.error(`Invalid coordinates for state: ${state}`);
      map.removeLayer(layer);
      return;
    }
    const dataSetName = selectedStrategy === 'Block Strategy' ? 'ai_block_town' : 'ai_district';
    const styleName =
      selectedStrategy === 'Block Strategy' ? 'ai_block_town' : 'ai_district_label_1692718543843_workview';

    const wmsParams = {
      access_token: `Bearer ${token}`,
      datasetNme: dataSetName,
      cql_filter: `state='${state}'`,
      srs: 'EPSG:3857',
      styles: styleName,
      service: 'WMS',
      request: 'GetMap',
      version: '1.1.1',
      env: 'polygonfillcolor:ffffff',
      transparent: true,
      format: 'image/png',
      autoZIndex: true,
    };
    var fillColor = 'polygonfillcolor:efefff';

    const wmsParams_block = {
      access_token: `Bearer ${token}`,
      datasetNme: dataSetName,
      height: map.innerHeight,
      width: map.innerWidth,
      cql_filter: `district in ('${selectedDistrict}')`,
      bbox: map.getBounds().toBBoxString(),
      srs: 'EPSG:3857',
      styles: styleName,
      service: 'WMS',
      request: 'GetMap',
      version: '1.1.1',
      env: fillColor,
      transparent: true,
      format: 'image/png',
      autoZIndex: true,
    };
    if (map && state) {
      map.setView([lat, lng], 7);

      map.eachLayer((layer) => {
        if (!(layer instanceof L.TileLayer)) {
          map.removeLayer(layer);
        }
      });

      const aiStateLayer = new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', wmsParams);
      aiStateLayer.addTo(map);

      //IDA:

      const IDA_Fail = countryProfile?.state['IDA Fail']?.map((item) => `'${item?.district}'`).join("'',''");

      if (IDA_Fail) {
        const IDAFailcolor = legends['IDA Fail'].replace("#","");
        const IFformattedDistricts1 = IDA_Fail.replace(/'/g, ''); // Removing single quotes
        const IFspacedDistricts1 = IFformattedDistricts1.replace(/,/g, "', '"); // Adding spaces after commas

        const IFcqlFilter1 = `district in ('${IFspacedDistricts1}')`;

        const IFwmsParams1 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: IFcqlFilter1,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${IDAFailcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const IFcreateAiStateLayer1 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayerIF = IFcreateAiStateLayer1(IFwmsParams1);
        aiStateLayerIF.addTo(map);
      }

      const IDA_Pass = countryProfile?.state['IDA Pass']?.map((item) => `'${item?.district}'`).join("'',''");

      if (IDA_Pass) {
        const IDAPasscolor = legends['IDA Pass'].replace("#","");
        const formattedDistricts1 = IDA_Pass.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts1 = formattedDistricts1.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter1 = `district in ('${spacedDistricts1}')`;

        const wmsParams1 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter1,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${IDAPasscolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer1 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer1 = createAiStateLayer1(wmsParams1);
        aiStateLayer1.addTo(map);
        console.log(wmsParams1, 'wsm1');
      }

      //DA

      
      const DA_Fail = countryProfile?.state['DA Fail']?.map((item) => `'${item?.district}'`).join("'',''");

      if (DA_Fail) {
        const DAFailcolor = legends['DA Fail'].replace("#","")
        const formattedDistricts1 = DA_Fail.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts1 = formattedDistricts1.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter1 = `district in ('${spacedDistricts1}')`;

        const wmsParams1 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter1,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${DAFailcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer1 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer1 = createAiStateLayer1(wmsParams1);
        aiStateLayer1.addTo(map);
      }
      const DA_Pass = countryProfile?.state['DA Pass']?.map((item) => `'${item?.district}'`).join("'',''");


      const DAPasscolor = legends['DA Pass'].replace("#","")
      const formattedDistricts2 = DA_Pass.replace(/'/g, '');
      const spacedDistricts2 = formattedDistricts2.replace(/,/g, "', '");

      const cqlFilter2 = `district in ('${spacedDistricts2}')`;
      const wmsParams2 = {
        access_token: `Bearer ${token}`,
        datasetNme: dataSetName,
        // cql_filter: "district in ('Saran','Patna','Gaya')",
        cql_filter: cqlFilter2,
        srs: 'EPSG:3857',
        styles: styleName,
        service: 'WMS',
        request: 'GetMap',
        version: '1.1.1',
        env: `polygonfillcolor:${DAPasscolor}`,

        transparent: true,
        format: 'image/png',
        autoZIndex: true,
      };

      const createAiStateLayer2 = (params) => {
        console.log(wmsParams2, 'fbgbgfbgfb');

        return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
      };

      const aiStateLayer2 = createAiStateLayer2(wmsParams2);
      aiStateLayer2.addTo(map);

      //PRE TAS
      const PreTAS_Pass = countryProfile?.state['Pre TAS Pass']?.map((item) => `'${item?.district}'`).join("'',''");

      if (PreTAS_Pass) {
        const PreTAS_Passcolor = legends['Pre TAS Pass'].replace("#","");
        const formattedDistricts3 = PreTAS_Pass.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts3 = formattedDistricts3.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter3 = `district in ('${spacedDistricts3}')`;

        const wmsParams3 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter3,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${PreTAS_Passcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer3 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer3 = createAiStateLayer3(wmsParams3);
        aiStateLayer3.addTo(map);
        console.log(wmsParams3, 'wsm3');
      }
      const PreTAS_Fail = countryProfile?.state['Pre TAS Pass']?.map((item) => `'${item?.district}'`).join("'',''");

      if (PreTAS_Fail) {
        const PreTAS_Failcolor = legends['Pre TAS Fail'].replace("#","");
        const formattedDistricts3 = PreTAS_Fail.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts3 = formattedDistricts3.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter3 = `district in ('${spacedDistricts3}')`;

        const wmsParams3 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter3,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${PreTAS_Failcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer3 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer3 = createAiStateLayer3(wmsParams3);
        aiStateLayer3.addTo(map);
        console.log(wmsParams3, 'wsm3');
      }

      
      //Under DA
      const Under_PreTAS = countryProfile?.state['Pending Pre TAS']?.map((item) => `'${item?.district}'`).join("'',''");

      if (Under_PreTAS) {
        const Under_PreTAScolor = legends['Under Pre TAS'].replace("#","");
        const formattedDistricts3 = Under_PreTAS.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts3 = formattedDistricts3.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter3 = `district in ('${spacedDistricts3}')`;

        const wmsParams3 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter3,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${Under_PreTAScolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer3 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer3 = createAiStateLayer3(wmsParams3);
        aiStateLayer3.addTo(map);
        console.log(wmsParams3, 'wsm3');
      }

      //Under DA
      const Under_DA = countryProfile?.state['Pending DA']?.map((item) => `'${item?.district}'`).join("'',''");

      if (Under_DA) {
        const Pending_DAcolor = legends['Under DA'].replace("#","");
        const formattedDistricts3 = Under_DA.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts3 = formattedDistricts3.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter3 = `district in ('${spacedDistricts3}')`;

        const wmsParams3 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter3,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${Pending_DAcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer3 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer3 = createAiStateLayer3(wmsParams3);
        aiStateLayer3.addTo(map);
        console.log(wmsParams3, 'wsm3');
      }

      //Under_IDA;
      const Under_IDA = countryProfile?.state['Pending IDA'].map((item) => `'${item.district}'`).join("'',''");

      if (Under_IDA) {
        const Pending_IDAcolor = legends['Under IDA'].replace("#","");
        const formattedDistricts4 = Under_IDA.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts4 = formattedDistricts4.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter4 = `district in ('${spacedDistricts4}')`;

        const wmsParams4 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter4,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${Pending_IDAcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer4 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer4 = createAiStateLayer4(wmsParams4);
        aiStateLayer4.addTo(map);
        console.log(wmsParams4, 'wsm4');
      }
      //PMS1
      // const PMS1 = countryProfile?.state['PMS1'].map((item) => `'${item.district}'`).join("'',''");

      // console.log(PMS1, 'PMS1');
      // if (PMS1) {
      //   const formattedDistricts5 = PMS1.replace(/'/g, ''); // Removing single quotes
      //   const spacedDistricts5 = formattedDistricts5.replace(/,/g, "', '"); // Adding spaces after commas

      //   const cqlFilter5 = `district in ('${spacedDistricts5}')`;

      //   const wmsParams5 = {
      //     access_token: `Bearer ${token}`,
      //     datasetNme: dataSetName,
      //     // cql_filter: "district in ('Saran','Patna','Gaya')",
      //     cql_filter: cqlFilter5,
      //     srs: 'EPSG:3857',
      //     styles: styleName,
      //     service: 'WMS',
      //     request: 'GetMap',
      //     version: '1.1.1',
      //     env: `polygonfillcolor:a96192`,
      //     transparent: true,
      //     format: 'image/png',
      //     autoZIndex: true,
      //   };

      //   const createAiStateLayer5 = (params) => {
      //     return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
      //   };
      //   const aiStateLayer5 = createAiStateLayer5(wmsParams5);
      //   aiStateLayer5.addTo(map);
      //   console.log(wmsParams5, 'wsm5');
      // }
      // //PMS2;
      // const PMS2 = countryProfile?.state['PMS2'].map((item) => `'${item.district}'`).join("'',''");

      // console.log(PMS2, 'PMS2');
      // if (PMS2) {
      //   const formattedDistricts6 = PMS2.replace(/'/g, ''); // Removing single quotes
      //   const spacedDistricts6 = formattedDistricts6.replace(/,/g, "', '"); // Adding spaces after commas

      //   const cqlFilter6 = `district in ('${spacedDistricts6}')`;

      //   const wmsParams6 = {
      //     access_token: `Bearer ${token}`,
      //     datasetNme: dataSetName,
      //     // cql_filter: "district in ('Saran','Patna','Gaya')",
      //     cql_filter: cqlFilter6,
      //     srs: 'EPSG:3857',
      //     styles: styleName,
      //     service: 'WMS',
      //     request: 'GetMap',
      //     version: '1.1.1',
      //     env: `polygonfillcolor:9e1ecf`,
      //     transparent: true,
      //     format: 'image/png',
      //     autoZIndex: true,
      //   };

      //   const createAiStateLayer6 = (params) => {
      //     return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
      //   };

      //   const aiStateLayer6 = createAiStateLayer6(wmsParams6);
      //   aiStateLayer6.addTo(map);
      //   console.log(wmsParams6, 'wsm6');
      // }
      // //PMS3
      // const PMS3 = countryProfile?.state['PMS3'].map((item) => `'${item.district}'`).join("'',''");

      // console.log(PMS3, 'PMS3');
      // if (PMS3) {
      //   const formattedDistricts7 = PMS3.replace(/'/g, '');
      //   const spacedDistricts7 = formattedDistricts7.replace(/,/g, "', '"); // Adding spaces after commas

      //   const cqlFilter7 = `district in ('${spacedDistricts7}')`;

      //   const wmsParams7 = {
      //     access_token: `Bearer ${token}`,
      //     datasetNme: dataSetName,
      //     // cql_filter: "district in ('Saran','Patna','Gaya')",
      //     cql_filter: cqlFilter7,
      //     srs: 'EPSG:3857',
      //     styles: styleName,
      //     service: 'WMS',
      //     request: 'GetMap',
      //     version: '1.1.1',
      //     env: `polygonfillcolor:1eaacf`,
      //     transparent: true,
      //     format: 'image/png',
      //     autoZIndex: true,
      //   };

      //   const createAiStateLayer7 = (params) => {
      //     console.log(params, 'wsm7');

      //     return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
      //   };

      //   const aiStateLayer7 = createAiStateLayer7(wmsParams7);
      //   aiStateLayer7.addTo(map);
      // }

      //TAS 1

      
      const TAS1_Fail = countryProfile?.state['TAS 1 Fail']?.map((item) => `'${item?.district}'`).join("'',''");

      if (TAS1_Fail) {
        const TAS1_Failcolor = legends['TAS 1 Fail'].replace("#","");
        const formattedDistricts1 = TAS1_Fail.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts1 = formattedDistricts1.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter1 = `district in ('${spacedDistricts1}')`;

        const wmsParams1 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilter1,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${TAS1_Failcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer1 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer1 = createAiStateLayer1(wmsParams1);
        aiStateLayer1.addTo(map);
      }

      const TAS1_Array = countryProfile?.state['TAS 1 Pass'];

      if (TAS1_Array !== undefined && TAS1_Array !== null && TAS1_Array.length > 0) {
        const TAS1_Passcolor = legends['TAS 1 Pass'].replace("#","")
        const TAS1 = TAS1_Array.map((item) => `'${item.district}'`).join("'',''");

        const formattedDistricts8 = TAS1.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts8 = formattedDistricts8.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter8 = `district in ('${spacedDistricts8}')`;

        const wmsParams8 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          //    height: window.innerHeight,
          //     width: window.innerWidth,
          bbox: map.getBounds().toBBoxString(),
          cql_filter: cqlFilter8,
          srs: 'EPSG:3857',
          // styles: 'ai_district_label_1692718543843_workview',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${TAS1_Passcolor}`,
          // env: `polygonfillcolor:${color}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer8 = (params) => {
          return overlay('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer8 = createAiStateLayer8(wmsParams8);
        aiStateLayer8.addTo(map);
        console.log(wmsParams8, 'wsm8');
      }

      //TAS 2
      const TAS2_Fail = countryProfile?.state['TAS 2 Fail']?.map((item) => `'${item?.district}'`).join("'',''");

      if (TAS2_Fail) {
        const TAS2_Failcolor = legends['TAS 2 Fail'].replace("#","");
        const formattedDistrictsTF2 = TAS1_Fail.replace(/'/g, ''); // Removing single quotes
        const spacedDistrictsTF2 = formattedDistrictsTF2.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilterTF2 = `district in ('${spacedDistrictsTF2}')`;

        const wmsParamsTF2 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilterTF2,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${TAS2_Failcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayerTF2 = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayerTF2 = createAiStateLayerTF2(wmsParamsTF2);
        aiStateLayerTF2.addTo(map);
      }
      const TAS2_Array = countryProfile?.state['TAS 2 Pass'];

      if (TAS2_Array !== undefined && TAS2_Array !== null && TAS2_Array.length > 0) {
        const TAS2_Passcolor = legends['TAS 2 Pass'].replace("#","");
        const TAS2 = TAS2_Array.map((item) => `'${item.district}'`).join("'',''");

        const formattedDistricts9 = TAS2.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts9 = formattedDistricts9.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter9 = `district in ('${spacedDistricts9}')`;

        const wmsParams9 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          //    height: window.innerHeight,
          //     width: window.innerWidth,
          bbox: map.getBounds().toBBoxString(),
          cql_filter: cqlFilter9,
          srs: 'EPSG:3857',
          // styles: 'ai_district_label_1692718543843_workview',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${TAS2_Passcolor}`,
          // env: `polygonfillcolor:${color}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer9 = (params) => {
          return overlay('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer9 = createAiStateLayer9(wmsParams9);
        aiStateLayer9.addTo(map);
        console.log(wmsParams9, 'wsm9');
      }

      //TAS 3
      const TAS3_Fail = countryProfile?.state['TAS 3 Fail']?.map((item) => `'${item?.district}'`).join("'',''");

      if (TAS3_Fail) {
        const TAS3_Failcolor = legends['TAS 3 Fail'].replace("#","");
        const formattedDistrictsT3F = TAS3_Fail.replace(/'/g, ''); // Removing single quotes
        const spacedDistrictsT3F = formattedDistrictsT3F.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilterT3F = `district in ('${spacedDistrictsT3F}')`;

        const wmsParamsT3F = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          // cql_filter: "district in ('Saran','Patna','Gaya')",
          cql_filter: cqlFilterT3F,
          srs: 'EPSG:3857',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${TAS3_Failcolor}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayerT3F = (params) => {
          return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayerT3F = createAiStateLayerT3F(wmsParamsT3F);
        aiStateLayerT3F.addTo(map);
      }
      const TAS3_Array = countryProfile?.state['TAS 3 Pass'];

      if (TAS3_Array !== undefined && TAS3_Array !== null && TAS3_Array.length > 0) {
        
        const TAS3_Passcolor = legends['TAS 3 Pass'].replace("#","");
        const TAS3 = TAS3_Array.map((item) => `'${item.district}'`).join("'',''");

        const formattedDistricts10 = TAS3.replace(/'/g, ''); // Removing single quotes
        const spacedDistricts10 = formattedDistricts10.replace(/,/g, "', '"); // Adding spaces after commas

        const cqlFilter10 = `district in ('${spacedDistricts10}')`;

        const wmsParams10 = {
          access_token: `Bearer ${token}`,
          datasetNme: dataSetName,
          //    height: window.innerHeight,
          //     width: window.innerWidth,
          bbox: map.getBounds().toBBoxString(),
          cql_filter: cqlFilter10,
          srs: 'EPSG:3857',
          // styles: 'ai_district_label_1692718543843_workview',
          styles: styleName,
          service: 'WMS',
          request: 'GetMap',
          version: '1.1.1',
          env: `polygonfillcolor:${TAS3_Passcolor}`,
          // env: `polygonfillcolor:${color}`,
          transparent: true,
          format: 'image/png',
          autoZIndex: true,
        };

        const createAiStateLayer10 = (params) => {
          return overlay('https://mgis-apiv2.mappls.com/map/getMap', params);
        };

        const aiStateLayer10 = createAiStateLayer10(wmsParams10);
        aiStateLayer10.addTo(map);
      }

      //DA COMPLETD BLOCK
      const DA_COMPLETED_BLOCK = countryProfile?.state['DA Pass']
        ?.map((item) => `'${item?.['Blocks Name']}'`)
        .join("'',''");
      const formattedDistrictsBlock2 = DA_COMPLETED_BLOCK.replace(/'/g, '');

      const spacedDistrictsBlock2 = formattedDistrictsBlock2.replace(/,/g, "', '");

      // const cqlFilterBlock2 = `block_town in('${spacedDistrictsBlock2}')`;
      const cqlFilterBlock2 = `block_town in('Devadurga','Lingsugur')`;

      console.log(spacedDistrictsBlock2, 'spacedDistrictsBlock2');

      const wmsParamsBlock2 = {
        access_token: `Bearer ${token}`,
        datasetNme: dataSetName,
        // cql_filter: "district in ('Saran','Patna','Gaya')",
        cql_filter: cqlFilterBlock2,
        srs: 'EPSG:3857',
        styles: 'ai_block_town',
        service: 'WMS',
        request: 'GetMap',
        version: '1.1.1',
        env: `polygonfillcolor:0000ff`,
        test: 0.2913425044164293,
        transparent: true,
        format: 'image/png',
        // format: 'image%2Fpng',

        // format: 'image%2Fpng',

        autoZIndex: false,
      };

      const createAiStateLayerBlock2 = (params) => {
        console.log(wmsParamsBlock2, 'wmsParamsBlock2');
        return new L.TileLayer.WMS('https://mgis-apiv2.mappls.com/map/getMap', params);
      };

      const aiStateLayerBlock2 = createAiStateLayerBlock2(wmsParamsBlock2);
      aiStateLayerBlock2.addTo(map);
    }
  };

  useEffect(() => {
    const mapInstance = L.map(mapRef.current, {
      center: [25.0961, 85.3131],
      attributionControl: false,
      zoom: 4,
      zoomControl: true,
      scrollWheelZoom: false,
      dragging: true,
    });

    setMap(mapInstance);

    return () => {
      if (mapInstance) {
        mapInstance.remove();
      }
    };
  }, []);
  console.log(map, 'map');
  console.log(selectedState, 'selectedState');

  useEffect(() => {
    if (map && map !== null && selectedState) {
      addStateLayer(selectedState, selectedStateYear.Year);

      // eslint-disable-next-line func-names
      map.on('click', function (event) {
        const point = map.latLngToContainerPoint(event.latlng, map.getZoom());
        const size = map.getSize();
        const params = {
          request: 'GetFeatureInfo',
          datasetNme: 'ai_district',
          styles: 'ai_district',
          service: 'WMS',
          // srs: 'EPSG:4326',
          transparent: true,
          format: 'image/png',
          bbox: map.getBounds().toBBoxString(),
          height: size.y,
          width: size.x,
          buffer: 15,
          crossDomain: true,
          version: '1.1.1',
          x: parseInt(point.x, 10),
          y: parseInt(point.y, 10),
        };

        if (selectedState) {
          params['cql_filter'] = `state = '${selectedState}'`;
        }
        var geoserver = 'https:///mgis-apiv2.mappls.com/map/getFeatureInfo';
        var urls = geoserver + L.Util.getParamString(params, geoserver, false);
        console.log(params);
        axios
          .get(urls, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            const response = res.data.featureInfo.featureInfo[0];
            console.log('log API', response);

            //

            const popupList =
              `<div style="width:100%; height:150px; background-color:#FFFFFF;"><div class="toolTipTextSec">` +
              `        <div><label>STRATEGY</label><span> : ${Strategy}</span></div>` +
              `        <div><label>STATE NAME</label><span> : ${response?.properties?.state}</span></div>` +
              `        <div><label>DISTRICT</label><span> : ${response?.properties?.district}</span></div>` +
              `        <div><label>ENDEMIC DISTRICTS</label><span> : ${EndemicDistricts}</span></div>` +
              `        <div><label>ENDEMIC POPULATIONS</label><span> : ${endemicPopulations}</span></div>` +
              `        <div><label>MDA DISTRICTS</label><span> : ${MDADistricts}</span></div>` +
              `        <div><label>PRE TAS DISTRICTS</label><span> : ${PreTASDistricts}</span></div>` +
              `        <div><label>TAS CLEARED DISTRICTS</label><span> : ${TASclearedDistricts}</span></div>` +
              `</div>` +
              `</div>`;

            const popup = L.popup();
            popup.setLatLng(event.latlng).setContent(popupList).openOn(map);

            console.log('you clicked latlng at :', event.latlng);
          })
          .catch((error) => console.log(error));
      });
    }
  }, [map, selectedState, selectedStateYear, addStateLayer, countryProfile.state.type, countryProfileMap]);

  return (
    <div style={{ margin: '0 auto', textAlign: 'center' }}>
      <div id="map" ref={mapRef} style={{ minHeight: '80vh', background: 'none', height: 'auto', width: '100%' }} />
    </div>
  );
};

MapComponent.propTypes = {
  selectedState: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  selectedStateYear: PropTypes.arrayOf(object).isRequired,
  countryProfileMap: PropTypes.arrayOf(PropTypes.object).isRequired,
  stateCoordinates: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
};

export default MapComponent;